import React from 'react';
import { Typography, Stack } from '@mui/material';
import RentlePaymentsLogoSvg from 'common/assets/rentle-logo/rentle-payments_black.svg';

const RentlePaymentsLogo = () => {
	return (
		<Stack alignItems="flex-start" justifyContent="center" width="100%" maxWidth="197px">
			<Stack mr={2}>
				<img src={RentlePaymentsLogoSvg} alt="Rentle Payments" width="100%" />
				<Stack pt={0.75}>
					<Typography align="right" variant="caption" color="textSecondary">
						{'Powered by Adyen'}
					</Typography>
				</Stack>
			</Stack>
		</Stack>
	);
};

export default RentlePaymentsLogo;
